import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function PresidentAddressMetaData(
  section: string,
): PageMetaDataValues {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: "Parlimen Ke-15",
    startDate: "2025-09-05",
    endDate: "2025-09-20",
    eventStatus: "https://schema.org/EventScheduled",
    eventAttendanceMode: "https://schema.org/MixedEventAttendanceMode",
    location: {
      "@type": "Place",
      name: "Singapore",
      address: {
        "@type": "PostalAddress",
        streetAddress: "1000 Toa Payoh North",
        addressLocality: "Singapore",
        postalCode: "318994",
        addressCountry: "Singapore",
      },
    },
  };
  const metaTags: MetaTagsProps = {
    title:
      "Ucapan President Tharman di Parlimen Ke-15 SG - Dasar & Prioriti Kerajaan",
    description:
      "President Tharman Shanmugaratnam menyampaikan ucapan pembukaan di Parlimen Ke-15 SG, menggariskan dasar kerajaan, keutamaan nasional, program ekonomi, dan hala tuju Singapura 2025.",
    slug: section,
    jsonLd,
  };

  const gaData: GADataProps = {
    level2: section,
    title: "Parlimen_Ke-15_Index",
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  return {
    gaData,
    metaTags,
  };
}
